import type { LayoutRuntime } from "../../../../shared/layouts/registry";

export const livescoreKeo88Layout: LayoutRuntime = {
  feature: "livescore",
  layout: "keo88",
  rootClass: "gwd-livescore-layout--keo88",
};
